import { API_CALL } from 'actions/actionConstants'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'
import { GoogleLoginData } from 'actions/AuthActions'
import { AppAction } from 'actions/types/ActionTypes'
import { requestPostGoogleLinkPersonalAccount } from 'businessTraveller/api/requestPostGoogleLinkPersonalAccount'

export function loginGoogle(data: GoogleLoginData): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const transformedData = {
      ...data,
      country_code: state.geo.currentRegionCode,
      signup_domain: window.location.hostname,
    }

    dispatch({
      type: API_CALL,
      api: BUSINESS_TRAVELLER_API_ACTIONS.USER_LINK_PERSONAL_ACCOUNT,
      request: () => requestPostGoogleLinkPersonalAccount(transformedData).then(data => {
        window.dispatchEvent(new CustomEvent('google-login-success', {
          detail: { email: transformedData.email }
        }))
        return data
      }),
      source: 'email',
    })
  }
}
